@let isCustomDeleted = isDisabled() && getCustomValueState('id');

<mat-expansion-panel
  class="cta-expansion-panel"
  [class.analytics-mode-panel]="analyticsMode()"
  [class.view-mode]="isViewMode()"
  [disabled]="isCustomDeleted || analyticsMode()"
  [expanded]="(isPanelExpanded() && !isCustomDeleted) || analyticsMode()"
  [hideToggle]="analyticsMode()"
  (expandedChange)="onPanelExpandedChange($event)"
>
  <mat-expansion-panel-header class="deliverable-flow-expansion-panel-header">
    <mat-panel-title>
      <div class="flex flex-1 justify-between items-center">
        <div class="flex flex-grow flex-col mr-8">
          <div class="flex gap-2">
            <app-editable-title
              fontClasses="font-bold"
              [class.text-sm]="!analyticsMode()"
              [icon]="form().invalid ? 'icons/circle-x.svg' : 'icons/circle-check.svg'"
              [iconColor]="form().invalid ? 'var(--shikenso-error-bright)' : 'var(--shikenso-pink-base)'"
              [iconSize]="16"
              [subtitle]="
                'pages.campaignForm.ctaDialog.ctaDetails.deliverables.productPlacementsDeliverable.subtitle' | translate
              "
              [control]="name"
              [isViewMode]="isViewMode()"
              [disabled]="isCustomDeleted"
              [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
              [infoTooltip]="
                'pages.campaignForm.ctaDialog.ctaDetails.deliverables.descriptions.productPlacement' | translate
              "
              [creatorBriefingMode]="creatorBriefingMode()"
              [showRequiredBadge]="showRequiredBadge()"
            />

            @if (showSeparator()) {
              <hr class="flex-1 ml-2 pb-0.5 border border-shikenso-purple-base-12 self-center" />
            }
          </div>
          @if (description()) {
            <div class="text-xs">{{ description() }}</div>
          }
        </div>

        @if (!isViewMode()) {
          <div class="flex items-center gap-7">
            <app-deliverable-advanced-button
              [platformFeature]="platformFeature()"
              [deliverableType]="form().value.type"
              [isOpen]="showAdvancedSettings()"
              (toggled)="onToggleAdvancedSettings()"
            />

            <div class="flex items-center">
              @if (isCustomMode() && !form().value.exclusiveTo) {
                <app-custom-remove-button
                  [checked]="!getCustomValueState('id')"
                  (checkboxStateChanged)="onDeleteCheckboxChange('id', $event)"
                  #deleteParentButton
                />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-transparent-button-color"
                  (click)="onDeleteClick(form().value.exclusiveTo)"
                >
                  <app-icon src="/icons/trash.svg" alt="delete" [size]="16" />
                </button>
              }
            </div>
          </div>
        }
      </div>
    </mat-panel-title>

    @if (isCustomDeleted) {
      <svg
        class="absolute top-1/2 -translate-y-1/2 right-1 opacity-[24%] w-6 h-6 mt-[1px]"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path>
      </svg>
    }
  </mat-expansion-panel-header>

  <div class="flex flex-col flex-1 gap-3" [formGroup]="form()">
    <div class="flex items-start gap-2">
      <mat-form-field
        class="w-full min-w-0"
        matTooltipPosition="above"
        [class.custom-value-border]="
          isCustomMode() && !isViewMode() && (form().value.exclusiveTo || getCustomValueState('productName'))
        "
        [matTooltip]="isViewMode() ? form().controls['productName'].value : null"
      >
        <mat-label>
          {{
            'pages.campaignForm.ctaDialog.ctaDetails.deliverables.productPlacementsDeliverable.placeholder' | translate
          }}
        </mat-label>
        <input matInput formControlName="productName" />

        @if (isCustomMode() && !isViewMode() && !form().value.exclusiveTo && getCustomValueState('productName')) {
          <span matSuffix>
            <button
              mat-icon-button
              type="button"
              class="mat-secondary-transparent-button-color"
              [disabled]="isCustomDeleted"
              (click)="onRevertToGlobalClick('productName')"
            >
              <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
            </button>
          </span>
        }
        <mat-error [control]="form().get('productName')" />
      </mat-form-field>

      @if (analyticsObjective(); as objective) {
        @if (isViewMode() && showStatusBadge() && manualDeliverableStatusConfig()?.statusVisible) {
          <div class="ml-1 pt-3">
            <app-analytics-status-badge
              [status]="objective.status"
              [currentCount]="objective.findingsCount"
              [loading]="objective.loading"
              [showPillLoader]="true"
              [showJumpAction]="true"
              [jumpActionDisabled]="!objective.findingsCount"
              (jumpAction)="objective.jump()"
            />
          </div>
        }
      }
    </div>

    <div formArrayName="images" class="flex flex-1 flex-col gap-[14px]">
      @for (imageControl of images.controls; track imageControl; let i = $index) {
        @if (
          !imageControl.value.exclusiveTo ||
          isViewMode() ||
          (isCustomMode() && imageControl.value.exclusiveTo === creatorId())
        ) {
          <ng-container [formGroupName]="i">
            <div
              class="flex items-center gap-2 -mb-10 transition-colors duration-300 rounded-lg -mx-3 px-3 -my-1 py-1"
              [class.bg-shikenso-pink-base-12]="isNewlyAddedImage(imageControl.value.id ?? '')"
              [class.pr-8]="isViewMode()"
              [class.mr-0]="isViewMode()"
              [attr.data-element-id]="imageControl.value.id ?? ''"
            >
              <app-file-uploader
                #fileUploaderComponent
                class="w-full"
                size="big"
                [imageWidth]="60"
                [imageHeight]="60"
                [id]="imageControl.controls.id.value ?? ''"
                [imageId]="imageControl.controls.imageId.value"
                [title]="
                  'pages.campaignForm.ctaDialog.ctaDetails.deliverables.productPlacementsDeliverable.fileUploadTitle'
                    | translate
                "
                [fileForm]="imageControl.controls.imageFile"
                [displayRevertButton]="
                  isCustomMode() &&
                  !isViewMode() &&
                  !imageControl.value.exclusiveTo &&
                  getCustomValueState('imageId', i)
                "
                [isExclusive]="imageControl.value.exclusiveTo"
                [disabled]="(isCustomDeleted || imageControl.disabled) && !isViewMode() && isCustomMode()"
                [isViewMode]="isViewMode()"
                [requiredPermission]="[EPermissions.campaignCreate]"
                (imageSelected)="onImageSelected($event, imageControl.controls.id.value ?? '')"
                (imageRemoved)="onImageRemoved(imageControl.controls.id.value ?? '')"
                (reverted)="onRevertToGlobalClick('imageId', i)"
              />

              @if (!isViewMode()) {
                @if (isCustomMode() && !imageControl.value.exclusiveTo) {
                  <div
                    matTooltipPosition="left"
                    [matTooltip]="
                      (isCustomDeleted || (deleteChildButton.isChecked && isChildDeleteDisabled())) &&
                      !imageControl.disabled
                        ? ('pages.campaignForm.ctaDialog.ctaDetails.deliverables.lastSubItemCannotBeDisabled'
                          | translate)
                        : ''
                    "
                  >
                    <app-custom-remove-button
                      [checked]="!getCustomValueState('id', i)"
                      [disabled]="isCustomDeleted || (deleteChildButton.isChecked && isChildDeleteDisabled())"
                      (checkboxStateChanged)="onDeleteCheckboxChange('id', $event, i)"
                      #deleteChildButton
                    />
                  </div>
                } @else {
                  <div
                    matTooltipPosition="left"
                    [matTooltip]="
                      isCustomDeleted || isChildDeleteDisabled()
                        ? ('pages.campaignForm.ctaDialog.ctaDetails.deliverables.lastSubItemCannotBeDeleted'
                          | translate)
                        : lastActiveChildElementDetails().has(imageControl.controls.id.value ?? '')
                          ? ('pages.campaignForm.ctaDialog.ctaDetails.deliverables.productPlacementsDeliverable.lastActiveProductPlacementImageCannotBeDeleted'
                              | translate) +
                            lastActiveChildElementDetails().get(imageControl.controls.id.value ?? '')?.creatorNames
                          : ''
                    "
                  >
                    <button
                      mat-icon-button
                      class="mat-secondary-transparent-button-color"
                      [disabled]="
                        isCustomDeleted ||
                        isChildDeleteDisabled() ||
                        lastActiveChildElementDetails().has(imageControl.controls.id.value ?? '')
                      "
                      (click)="removeFileUploader(imageControl.controls.id.value ?? '')"
                    >
                      <app-icon src="/icons/trash.svg" alt="delete" [size]="16" />
                    </button>
                  </div>
                }
              }
            </div>
            <div class="w-full">
              <mat-error class="text-xs ml-10" [control]="imageControl.get('imageFile')" />
            </div>
          </ng-container>
        }
      }
    </div>
  </div>

  @if (images.length && !isViewMode()) {
    <div class="flex justify-start mt-[14px]">
      <button
        mat-flat-button
        color="secondary-transparent"
        class="w-fit mat-slim-button"
        (click)="addProductPlacementImage()"
      >
        <div class="flex items-center gap-1">
          <app-icon src="/icons/plus.svg" alt="add" class="w-5 h-5" />
          <span>
            {{
              'pages.campaignForm.ctaDialog.ctaDetails.deliverables.productPlacementsDeliverable.addImage' | translate
            }}
          </span>
        </div>
      </button>
    </div>
  }

  @if (showAdvancedSettings() && !isViewMode()) {
    <div class="pl-3 mt-4">
      <app-deliverable-advanced-settings-section
        [form]="form()"
        [platformFeature]="platformFeature()"
        [deliverableType]="form().value.type"
        [isCustomMode]="isCustomMode()"
        [creatorId]="creatorId()"
      />
    </div>
  }
</mat-expansion-panel>
